/* eslint-disable no-plusplus */
/* eslint-disable import/prefer-default-export */
export const validateSequence = (screens) => {
  const orders = screens.map((screen) => screen.displayOrder).sort((a, b) => a - b);
  if (orders[0] !== 1) return false;
  for (let i = 0; i < orders.length - 1; i++) {
    if (orders[i] + 1 !== orders[i + 1]) {
      return false;
    }
  }
  return true;
};
